import { getRequest, postRequest } from './util';
var getReports = function () { return getRequest('/reports'); };
var createReport = function (reportCreateRequest) { return postRequest('/reports/scans', reportCreateRequest); };
export default {
    getReports: getReports,
    createReport: createReport,
};
